(function () {
  angular.module('app', [
    'app.core.api.interceptor.ready',
    'app.core.invites.ready',
    'app.main',
    'app.widgets.common.feature',
    'app.widgets.common.go-url',
    'app.widgets.common.ie-eleven-notification',
    'app.widgets.common.language-switcher',
    'binky.core.api.ready',
    'binky.core.authentication.ready',
    'binky.core.configuration.ready',
    'binky.core.feature.ready',
    'binky.core.locale.ready',
    'binky.core.lodash',
    'binky.core.promise-utils',
    'binky.core.ready',
    'binky.core.src2-migration',
    'rcAngular',
    'rcCommerce',
    'rcControllers',
    'rcDirectives',
    'rcEntities',
    'rcFilters',
    'rcLocalization',
    'rcServices',
    'tmh.dynamicLocale',
  ]);
})();
